module.exports = __webpack_public_path__ + "img/tintuc4.5286d318.png";